export const BAR_PARFUM_OPEN_EVENT = "bar-parfum:open";

export function shouldOpenBarParfum(pathname: string): boolean {
  const path = pathname.replace(/\/+$/, "") || "/";
  return path === "/" || path === "/contactez-nous" || path === "/dj-mariage" || path === "/bar-a-parfum" || path.startsWith("/dj-mariage/");
}